import { useState, type ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router';
import { cn, RoutePaths } from '@shared/utils';
import type { GetAccountsResponse, GetCardsResponse } from '@shared/api';

interface SlideItemProps {
  className?: string;
  style?: { width: string | number; height: string | number };
  account?: GetAccountsResponse;
  card?: GetCardsResponse;
  accountsPage?: boolean;
  onSelectedCard?: (card: GetCardsResponse | undefined) => void;
  children: ReactNode;
}

export const SlideItem = (props: SlideItemProps) => {
  const params = useParams();
  const navigate = useNavigate();

  const [active, setActive] = useState<boolean>(false);

  const flipItem = () => {
    if (props.accountsPage) !isActive && navigate(RoutePaths.accounts.onNavigate(props.account?.Id as string));
    if (props.onSelectedCard) props.onSelectedCard(props.card);
    setActive((prev) => !prev);
  };

  const isActive = params.id === props.account?.Id;
  return (
    <div className={props.className} style={props.style} onClick={flipItem}>
      <div className='h-full w-full perspective-[1000px]'>
        <div
          className={cn(
            'relative h-full transition-all duration-600',
            props.accountsPage ? (isActive ? 'rotate-y-180' : '') : active ? 'rotate-y-180' : '',
          )}
          style={{ transformStyle: 'preserve-3d' }}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
};
